import {Container} from "@mui/material";
import styled from "styled-components";
import {UserContainer} from "../ConfirmedOfferPage/ConfirmedOfferPage.styles";

export const BasicContainer = styled(Container)`
    padding-top: 1rem;
    overflow: auto;
    height: 100%;
`

export const TitleContainer = styled.div`
    padding: 1.275rem 1rem;
    border-radius: 1rem;
    margin-bottom: 1rem;
    box-shadow: rgba(0, 0, 0, 0.05) 0px 1px 4px, rgb(51, 51, 51, 0.5) 0px 0px 0px 2px;
`

export const Title = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-bottom: 0.5rem;
    padding-bottom: 0.5rem;
    font-size: 1rem;
    line-height: 1.3;
    color: #000;
    border-bottom: 1px solid rgba(0, 0, 0, 0.15);
    @media (min-width: 768px) {
        font-size: var(--typography-h5-size);
    }
`

export const ValueBox = styled.div`
    color: var(--text-primary, rgba(0, 0, 0, 0.87));
    font-feature-settings: 'clig' off, 'liga' off;
    
    font-size: var(--font-size-mid);
    font-style: normal;
    line-height: 133.4%; /* 32.016px */
    margin: 0.25rem 0;
    display: flex;
    flex-direction: row;
    gap: 1rem;
    align-items: center;
    white-space: pre-wrap;
`

export const Value = styled.h4`
    color: var(--text-primary, rgba(0, 0, 0, 0.87));
    font-feature-settings: 'clig' off, 'liga' off;

    font-size: var(--font-size-mid);
    font-style: normal;
    line-height: 123.5%;
    letter-spacing: 0.25px;
    margin: 0.25rem 0;
    align-items: center;
`

export const ClickContainer = styled.div`
    cursor: pointer;
`

export const PaymentTerms = styled(ValueBox)`
    text-align: center;
    display: flex;
    align-items: center;
    margin: 0.25rem 0;
`

export const TermsContainer = styled(ValueBox)`
    justify-content: space-between;
    flex-wrap: wrap;
`


export const SimpleButton = styled.button`
    background-color: unset;
    border: none;
    color: var(--secondary-main);
    text-decoration: underline;
    font-size: 14px;
    cursor: pointer;
    padding: unset;
`

export const Subtitle = styled.div`
    font-size: var(--font-size-mid);
    line-height: 1.5;
    color: rgb(0, 0, 0, 0.7);
    font-weight: 400;
    margin: 0.25rem 0;
`

export const UserContainerWithBorder = styled(UserContainer)`
    padding: 0.5rem 1rem;
    box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px, rgb(51, 51, 51, 0.3) 0px 0px 0px 1px;
    border-radius: var(--2, 1rem);
    color: var(--secondary-main);
    background: unset;
`

export const TopContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    @media only screen and (max-width: 600px) {
        font-size: 1rem;
        font-weight: 600;
        letter-spacing: 0.15px;
        flex-direction: column;
    }
`

export const LeftContainer = styled.div`
    display: flex;
    flex-direction: column;
    max-width: 50%;
    width: 100%;
    align-self: center;
    @media only screen and (max-width: 600px) {
        max-width: 100%;
    }
`

export const RightContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 1rem;
    @media only screen and (max-width: 600px) {
        justify-content: center;
    }
`

export const PartialHoursContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 0.5rem;
`

export const DashedCircle = styled.div`
  width: 1rem;
  height: 1rem;
  border: 2px dashed #f97316;
  border-radius: 50%;
`;

export const JobSeekingPill = styled.div`
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  border-radius: 12px;
  background-color: #e7f3fe;
  border: 1px solid #b3d7f9;
  color: #0B4598;
  font-size: 0.75rem;
  font-weight: 600;
  margin-left: 8px;
  white-space: nowrap;
`;

